<template>
  <div class="c-key-email">
    <label for="email" class="title">Informe seu e-mail</label>

    <div class="field-body column is-full">
      <div class="field">
        <div class="control">
          <input
            id="email"
            class="input has-value"
            placeholder="e-mail"
            name="email"
            type="email"
            autocomplete="off"
            v-model.lazy="email"
            @change="updateValue"
          />
          <i class="bar"></i>
          <p v-if="validation.hasError('email')" class="help is-error">
            Por favor, revise o e-mail informado.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleVueValidator from 'simple-vue-validator'

const Validator = SimpleVueValidator.Validator

export default {
  mixins: [SimpleVueValidator.mixin],

  data() {
    return {
      email: '',
    }
  },

  validators: {
    email: (value) => {
      return Validator.value(value).required().email()
    },
  },

  computed: {
    hasErrors() {
      return this.validation.hasError('email')
    },
  },

  methods: {
    async updateValue() {
      await this.$validate()
      this.$emit('change', {
        key: this.email,
        error: this.hasErrors,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.c-key-email {
  .title {
    margin-bottom: 40px;
    font-size: 20px;
    line-height: 100%;
    font-weight: bold;
    color: $gray-7;
  }

  .another-key {
    cursor: pointer;
    font-size: 18px;
    font-weight: 700;
    line-height: 21.6px;
    color: $support;
    margin-bottom: 50px;
    i {
      margin-left: 4px;
      font-size: medium;
    }
  }

  input {
    color: $neutral !important;
    font-size: 20px;
    font-weight: 700;
    line-height: 100%;
  }

  .field-body {
    padding-left: 0;
    margin-bottom: 50px;
  }
}
</style>
